/// <amd-module name="VSS/Features/PlatformUI/FPSLink" />
export { FPSLink } from "./Components/FPSLink/FPSLink";
export { IFPSLinkProps } from "./Components/FPSLink/FPSLink.Props";
